import React from 'react';
import { Box, Button, Skeleton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BRAND, BRAND_RADIUS } from '../../theme/brandTokens';

const SKELETON_HEIGHT = 96;

const DashboardCard = ({
  id,
  title,
  subtitle,
  action,
  isLoading = false,
  hasError = false,
  onRetry,
  minHeight,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      id={id}
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        height: '100%',
        minWidth: 0,
        minHeight,
        p: { xs: 2, sm: 2.5 },
        borderRadius: BRAND_RADIUS.card,
        border: `1px solid ${BRAND.line}`,
        bgcolor: BRAND.surface,
      }}
    >
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={1.5}>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography variant="subtitle1" component="h2" sx={{ fontWeight: 700, color: BRAND.text, lineHeight: 1.3 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="caption" sx={{ color: BRAND.textMuted, display: 'block' }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Stack>

      {hasError && (
        <Stack spacing={1} alignItems="flex-start">
          <Typography variant="body2" sx={{ color: BRAND.textMuted }}>
            {t('dashboard.states.error')}
          </Typography>
          {onRetry && (
            <Button size="small" onClick={onRetry} sx={{ textTransform: 'none' }}>
              {t('dashboard.states.retry')}
            </Button>
          )}
        </Stack>
      )}

      {!hasError && isLoading && (
        <Skeleton
          variant="rounded"
          height={SKELETON_HEIGHT}
          sx={{ transform: 'none', borderRadius: BRAND_RADIUS.card }}
        />
      )}

      {!hasError && !isLoading && children}
    </Box>
  );
};

export default DashboardCard;
